<template>
  <div>11</div>
</template>

<script>
export default {
  name: "AfterVerification",
  data() {
    return {
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      changePhoneNumberUrl: '/api/phone/changePhoneNumber',
      bindingPhoneNumberUrl: '/api/phone/bindingPhoneNumber',
    }
  },
  mounted() {
    if (this.$route.params.code === undefined || this.$route.params.code === null || this.$route.params.code !== 'cdjcaivi') {
      this.$router.go(-1)
      return
    }
    let data = this.$route.params.data
    switch (data['business']) {
      case "ChangePhoneNumber":
        this.ChangePhoneNumber(data['phone'], data['account'])
        this.$router.replace('/' + data['nextPage'])
        break;
      case "BindingPhoneNumber":
        this.BindingPhoneNumber(data['phone'])
        this.$router.replace('/' + data['nextPage'])
        break;
    }
  },
  methods: {
    BindingPhoneNumber(phone) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.bindingPhoneNumberUrl,
        params: {phone: phone, yhnm: that.yhnm},
        headers: {token: that.token}
      }).then((response) => {
        this.$messagebox.alert(response.data.message)
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    ChangePhoneNumber(phone, account) {
      let that = this
      that.$ajax({
        method: 'get',
        url: this.changePhoneNumberUrl,
        params: {phone: phone, zhnm: account},
        headers: {token: this.token}
      }).then((response) => {
        this.$messagebox.alert(response.data.message)
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style scoped>

</style>
